module.exports = __webpack_public_path__ + "static/media/mask.3a478cac.png";